import React, { useState } from 'react';
import "./CreateCompanyFooter.css";
import { Link, useLocation } from 'react-router-dom';
import { Button, Modal } from 'react-bootstrap';
import { openSignIn } from '../../features/modals/modalSlice';
import { useDispatch } from 'react-redux';
import { FaLinkedin } from 'react-icons/fa'; // ✅ Import

const CreateCompanyFooter = () => {
  const [show, setShow] = useState(false);

  const handleShow = () => setShow(true);
  const handleClose = () => setShow(false);
  const dispatch = useDispatch();
  const location = useLocation();

  return (
    <div className=''>
      <div className='position_company_footer'>
        <div className='padding_top_company_footer home_footer_bg'>
          <div className='container pt-lg-4 pt-md-4 pt-4 pb-lg-4 pb-md-4 pb-0'>
            <div className='row'>
              <div className="col-lg col-md-4 col-sm-6 col-12 mb-3">
                <div className="home_footer_box">
                  <div>
                    <h3 className='home_footer_h3 text-center mb-3'>Community</h3>
                    <Link to="/contact-us" className='home_footer_p mb-1'>Contact Us</Link>
                    <p className='mb-2'>
                      <Link to="/trending-news" className='home_footer_p mt-1'>Blog</Link>
                    </p>
                    {/* ✅ LinkedIn Icon Under Community */}
                    <div className="text-center mt-2">
                      <a
                        href="https://www.linkedin.com/company/ratemymanagerfyi/"
                        target="_blank"
                        rel="noopener noreferrer"
                        aria-label="LinkedIn"
                        style={{ color: "#0077b5", fontSize: "22px" }}
                      >
                        <FaLinkedin />
                      </a>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-lg col-md-4 col-sm-6 col-12 mb-3">
                <div className="home_footer_box">
                  <div className='pb-3'>
                    <h3 className='home_footer_h3 text-center mb-3'>Legal</h3>
                    <p className='mb-2'>
                      <Link to="/terms-of-use" className='home_footer_p'>Terms & Conditions</Link>
                    </p>
                    <p className='mb-2'>
                      <Link to="/privacy-policy" className='home_footer_p'>Privacy Policy</Link>
                    </p>
                    <Link to="/legal-guidelines" className='home_footer_p'>Legal Guidelines</Link>
                  </div>
                </div>
              </div>

              <div className="col-lg col-md-4 col-sm-6 col-12 mb-3">
                <div className="home_footer_box">
                  <div>
                    <h3 className='home_footer_h3 text-center mb-3'>Guide</h3>
                    <p
                      className='home_footer_p mb-1'
                      style={{ cursor: "pointer" }}
                      onClick={() => dispatch(openSignIn(location.pathname))}
                    >
                      Account
                    </p>
                  </div>
                </div>
              </div>

              {/* Bootstrap Modal */}
              <Modal show={show} onHide={handleClose} centered dialogClassName="custom-modal">
                <Modal.Body className="custom-modal-body">
                  <div className="modal-content-wrapper">
                    <h2 className="modal-title">✨ Something New is Coming! ✨</h2>
                    <p className="modal-text">
                      🚀 We're working on an exciting new feature. Stay tuned!
                    </p>
                    <Button variant="light" className="close-button" onClick={handleClose}>
                      Got It!
                    </Button>
                  </div>
                </Modal.Body>
              </Modal>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CreateCompanyFooter;